export type QuestionFormValue = {
  title: string;
  duration: number;
  tips: string;
};

export type TemplateFormValues = {
  name: string;
  questions: QuestionFormValue[];
};

export const emptyQuestion = (): QuestionFormValue => ({
  title: '',
  duration: 60,
  tips: '',
});
